<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header hint="Ketik nama toko" :enabled="false"/>
            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <!-- Title Page -->
                            <div class="col-auto">
                                <h2 class="page-title ">Tracking Outlet Active</h2>
                            </div>
                            
                            <div class="col-auto border-top-0">
                                <button class="btn btn-white ml-2" v-html="ic('filter')+' Filter'" @click="isModal"> </button>
                                <button class="btn btn-primary ml-2" v-html="ic('download')+'Download PDF'" @click="_createPdf"> </button>
                                <button class="btn btn-primary ml-2" v-html="ic('download')+'Download Excel'" @click="_createExcel"> </button>
                            </div>
                        </div>
                    </div>

                    <Skeleton type="table" :length="20" class="mt-4 bg-white" v-if="form.isLoading"/> 

                    <Nodata class="mt-5" v-if="datas.tracking_outlet_active.length === 0 && !form.isLoading"/>

                    <div class="box" v-if="datas.tracking_outlet_active.length > 0 && !form.isLoading">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter table-hover card-table table-striped table-control table-no-break">
                                    <thead class="text-muted py-4">
                                        <tr>
                                            <th class="text-center border-bottom-0 header" :colspan=form.colspan>
                                                Outlet Active  {{ `[WEEK  ${filters.start_week} ${filters.start_year} - WEEK ${filters.end_week} ${filters.end_year} ]` }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="sub-header">No</th>
                                            <th class="sub-header">Nama Supervisor</th>
                                            <th class="sub-header">Nama Team</th>
                                            <th class="sub-header" v-for="(value,key) in datas.tracking_outlet_active[0].detail_tracking">{{ key.replace('_', ' ') }}</th>
                                            <th class="sub-header">Average Week</th>
                                            <th class="sub-header">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-sm" style="font-size: 0.80rem;">
                                        <tr v-for="(trakcingOA, index) in datas.tracking_outlet_active" :key="index">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ trakcingOA.nama_spv }}</td>
                                            <td>{{ trakcingOA.nama_tim }}</td>
                                            <td v-for="(value,key) in trakcingOA.detail_tracking">{{ value }}</td>
                                            <td>{{ trakcingOA.avg_week }}</td>
                                            <td>{{ trakcingOA.total }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <ModalFilter></ModalFilter>
    </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
import ModalFilter from "./modals/filter.vue";
import helper from "@/assets/js/helper.js";
import jsPDF from "jspdf";
import XLSX from 'xlsx';

export default ({
    name: "TrackingOutletActive",
    components: { ModalFilter },
    mixins: [helper],
    computed: {
        ...mapState("trakcing_outlet_active",['filters','datas','form']),
    },
    methods: {
        ...mapActions("trakcing_outlet_active",['isModal']),

        _createPdf(){
            const dataOutletActive = this.datas.tracking_outlet_active 

            let doc = new jsPDF('landscape')
            let styles = { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 }
            // title
            doc.autoTable({
                theme: 'plain',
                styles: { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 },
                margin: { top: 10, left: 10, right: 10 },
                columnStyles: { 1: { halign: 'center', fontSize: 18 } },

                head: [['Laporan Outlet Active', '']],

                body: [
                ['Laporan Outlet Active', { content: "Laporan Outlet Active", rowSpan: 2, styles: { halign: 'right' } }],
                ['',],
                ['Data Received Week ' + this.filters.start_week + " / Year " + this.filters.start_year + ' until ' + this.filters.end_week + " / Year " + this.filters.end_year,],
                ],
            })

            let headers = ['Nama Supervisor', 'Nama Tim'];
            Object.keys(dataOutletActive[0].detail_tracking).forEach(key => {
                headers.push(key.replace('_', ' '))
            });
            headers.push("Average Week")
            headers.push("Total")

            let header = [headers], temp = [];

            dataOutletActive.forEach((outletActive) => {
                temp = [];
                temp.push(outletActive.nama_spv)
                temp.push(outletActive.nama_tim)
                let detailTracking = outletActive.detail_tracking 
                Object.keys(detailTracking).forEach(key => {
                    let week = detailTracking[key]
                    temp.push(week);
                });
                temp.push(outletActive.avg_week)
                temp.push(outletActive.total)
                header.push(temp)
            })
            styles['cellPadding'] = 2;

            doc.autoTable({ // body
                theme: 'grid', styles: styles, margin: { top: 10, left: 10, right: 10 },
                body: header,
            })
            this.pdfDownload([ doc.output() ])
        },

        _createExcel() {
            const dataOutletActive = this.datas.tracking_outlet_active 
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet([]);

            let content = [];
            content.push(['Laporan Outlet Active', '', '']);
            content.push(['', '', '']);
            content.push(['Data Received Week ' + this.filters.start_week + " / Year " + this.filters.start_year + ' until ' + this.filters.end_week + " / Year " + this.filters.end_year, '', '']);
            content.push(['', '', '']);

            let headers = ['Nama Supervisor', 'Nama Tim'];
            Object.keys(dataOutletActive[0].detail_tracking).forEach(key => {
                headers.push(key.replace('_', ' '))
            });
            headers.push("Average Week")
            headers.push("Total")
            content.push(headers)

            dataOutletActive.forEach((outletActive) => {
                let cell = [outletActive.nama_spv, outletActive.nama_tim]
                let detailTracking = outletActive.detail_tracking 
                Object.keys(detailTracking).forEach(key => {
                    let week = detailTracking[key]
                    cell.push(week);
                });
                cell.push(outletActive.avg_week)
                cell.push(outletActive.total)
                content.push(cell)
            })

            XLSX.utils.sheet_add_aoa(worksheet, content);
            const merge = [
                {
                s: { r: 0, c: 0 },
                e: { r: 0, c: 2 }
                },
                {
                s: { r: 2, c: 0 },
                e: { r: 2, c: 4 }
                }
            ]
            worksheet['!merges'] = merge;

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Outlet Active');
            XLSX.writeFile(workbook, 'laporan_tracking_oa_' + this.filters.start_week + '_sampai_' + this.filters.end_week + '.xlsx');
        },
    },
});
</script>

<style scoped>
    .header{
        font-size: 0.85rem;
        font-weight: 800;
    }
    .sub-header{
        font-size: 0.83rem;
        font-weight: 500;
    }
</style>
